'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420 from "./presto.-Dashboard-View$$anon$20.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024 from "./presto.types$-Dashboard-User-Stats$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$19() {
  this.aLy = null;
  this.aLq = null;
  this.aLr = false;
  this.aLz = null;
  this.aLA = false;
  this.aLD = null;
  this.aLw = null;
  this.aLx = false;
  this.aLs = null;
  this.aLt = false;
  this.aLu = null;
  this.aLv = false;
  this.aLB = false;
  this.aLC = false;
  this.aLy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLD = "DashboardUserStats";
}
export { $c_Lpresto_DashboardView$$anon$19 as $c_Lpresto_DashboardView$$anon$19 };
$p = $c_Lpresto_DashboardView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$19;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$19() {
}
export { $h_Lpresto_DashboardView$$anon$19 as $h_Lpresto_DashboardView$$anon$19 };
$h_Lpresto_DashboardView$$anon$19.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aLy;
});
$p.M = (function() {
  if ((!this.aLr)) {
    this.aLq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aLr = true;
  }
  return this.aLq;
});
$p.O = (function() {
  if ((!this.aLA)) {
    this.aLz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLA = true;
  }
  return this.aLz;
});
$p.E = (function() {
  return this.aLD;
});
$p.t = (function() {
  if ((!this.aLx)) {
    this.aLw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aLx = true;
  }
  return this.aLw;
});
$p.N = (function() {
  if ((!this.aLt)) {
    this.aLs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aLt = true;
  }
  return this.aLs;
});
$p.Q = (function() {
  if ((!this.aLv)) {
    this.aLu = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420.$c_Lpresto_DashboardView$$anon$20();
    this.aLv = true;
  }
  return this.aLu;
});
$p.v = (function() {
  if ((!this.aLC)) {
    this.aLB = false;
    this.aLC = true;
  }
  return this.aLB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.cFV(p)))($j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024.$m_Lpresto_types$DashboardUserStats$())));
});
var $d_Lpresto_DashboardView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$19, "presto.DashboardView$$anon$19", ({
  Hh: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$19 as $d_Lpresto_DashboardView$$anon$19 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$19.js.map
